import { API_BASE } from "../config/api";
import React, { useState } from "react";
const base = API_BASE;
export default function MediaUpload({ id, kind, token, hasFile, pendingCleanup = false, published, disabled, onComplete, onBusy, onLogout }) {
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [preview, setPreview] = useState("");
  const [confirmRemove, setConfirmRemove] = useState(false);
  const [cleanupPending, setCleanupPending] = useState(pendingCleanup);
  async function api(path, body, method) {
    const response = await fetch(`${base}/api/admin/events/${id}/${path}`, { method: method || (body ? "POST" : "GET"), headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    if (response.status === 401) { onLogout(); throw new Error("Sessione scaduta."); }
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || "Operazione non riuscita.");
    return data;
  }
  async function upload(event) {
    const file = event.target.files[0]; event.target.value = "";
    if (!file) return;
    const limit = (kind === "video" ? 250 : 10) * 1024 * 1024;
    const allowed = kind === "video" ? ["video/mp4"] : ["image/jpeg", "image/png", "image/webp"];
    if (!allowed.includes(file.type) || file.size > limit || !file.size) { setError("Formato o dimensione non consentiti."); return; }
    setBusy(true); onBusy(true); setError(""); setPreview(""); setProgress(0);
    try {
      const { url, ticket } = await api("uploads", { kind, contentType: file.type, size: file.size });
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", url); xhr.timeout = 15 * 60 * 1000;
        xhr.setRequestHeader("Content-Type", file.type);
        xhr.upload.onprogress = event => { if (event.lengthComputable) setProgress(Math.round(event.loaded / event.total * 100)); };
        xhr.onload = () => xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error("Upload fallito. Verifica la policy CORS e riprova."));
        xhr.onerror = () => reject(new Error("Connessione interrotta o CORS non configurato. Seleziona nuovamente il file per riprovare."));
        xhr.ontimeout = () => reject(new Error("Tempo di caricamento scaduto. Riprova."));
        xhr.send(file);
      });
      const data = await api("uploads/complete", { ticket });
      setCleanupPending(Boolean(data.cleanupPending));
      onComplete(data.data.event);
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); onBusy(false); }
  }
  async function removeFile(cleanupOnly = false) {
    setBusy(true); onBusy(true); setError("");
    try {
      const data = await api(cleanupOnly ? "media-cleanup" : `media/${kind}`, undefined, cleanupOnly ? "POST" : "DELETE");
      if (!cleanupOnly) setPreview("");
      setConfirmRemove(false);
      setCleanupPending(Boolean(data.cleanupPending));
      onComplete(data.data.event);
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); onBusy(false); }
  }
  async function showPreview() {
    setError("");
    try { const data = await api(`media/${kind}`); setPreview(data.url); }
    catch (failure) { setError(failure.message); }
  }
  return <div className="rounded-lg border border-[#cbd3cc] p-4">
    <label className="block text-sm font-medium" htmlFor={`upload-${kind}`}>{kind === "video" ? "Carica video MP4 (max 250 MB)" : "Carica copertina JPEG, PNG o WebP (max 10 MB)"}</label>
    <input id={`upload-${kind}`} type="file" accept={kind === "video" ? "video/mp4" : "image/jpeg,image/png,image/webp"} disabled={busy || disabled} onChange={upload} className="mt-3 block w-full text-sm file:mr-3 file:rounded file:border-0 file:bg-[#263b3e] file:px-3 file:py-2 file:text-white disabled:opacity-50" />
    {busy && <div role="status" className="mt-3 text-sm"><progress aria-label="Avanzamento upload" max="100" value={progress} className="w-full" />{progress < 100 ? `Caricamento ${progress}%` : "Verifica e salvataggio…"}</div>}
    {hasFile && !busy && <p className="mt-3 text-sm text-emerald-800">File associato. <button type="button" disabled={disabled} onClick={showPreview} className="underline">Mostra anteprima</button></p>}
    {hasFile && !busy && <div className="mt-3">
      <button type="button" disabled={disabled || (kind === "video" && published)} onClick={() => setConfirmRemove(true)} className="text-sm text-red-800 underline disabled:opacity-50">{kind === "video" ? "Rimuovi video" : "Rimuovi copertina"}</button>
      {kind === "video" && published && <p className="mt-2 text-sm">Archivia prima l’evento per rimuovere il video.</p>}
    </div>}
    {confirmRemove && <div role="group" aria-label="Conferma rimozione file" className="mt-4 rounded border border-red-200 bg-red-50 p-4"><p>Rimuovere questo file dall’evento ed eliminarlo da R2? L’operazione non può essere annullata.</p><div className="mt-3 flex gap-4"><button type="button" disabled={busy || disabled} onClick={() => setConfirmRemove(false)} className="underline">Annulla</button><button type="button" disabled={busy || disabled || (kind === "video" && published)} onClick={() => removeFile()} className="text-red-800 underline">Conferma rimozione</button></div></div>}
    {cleanupPending && <div role="status" className="mt-3 text-sm text-amber-800">Evento aggiornato, ma alcuni file devono ancora essere eliminati da R2. <button type="button" disabled={busy || disabled} onClick={() => removeFile(true)} className="underline">Riprova pulizia</button></div>}
    {error && <p role="alert" className="mt-3 text-sm text-red-800">{error}</p>}
    {preview && (kind === "video" ? <video controls preload="metadata" src={preview} className="mt-3 max-h-72 w-full" /> : <img alt="Anteprima copertina" src={preview} className="mt-3 max-h-72 object-contain" />)}
  </div>;
}



